module.exports = __webpack_public_path__ + "img/BoD_03_Dr_Benjamin_Koh.775b7a8d.jpg";